import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { OrderHeader } from '../../_models/orderHeader';
import * as _ from "lodash";
import { StockShipmentLine } from '../../_models/stockShipmentLine';
import { OrderLine } from '../../_models/orderLine';
import { AlertService } from '../../_services/alert.service';
import { User } from "../../_models/user";

@Component({
  selector: 'app-return-process-order',
  templateUrl: './return-process-order.component.html',
  styleUrls: ['./return-process-order.component.scss'],
})
export class ReturnProcessOrderComponent implements OnInit {
  statusText1: string;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  statusText6: string;
  statusText7: string;
  statusText8: string;
  statusText9: string;
  statusText10: string;
  statusText11: string;
  statusText12: string;
  statusText13: string;
  invoiceReason: string;
  shipType: string;
  package: any = [];
  step: number = 1;
  viewReturnOrder: any;
  totalBoxes: number = 0;
  boxHeights: number = 0;
  boxWidths: number = 0;
  boxLengths: number = 0;
  numberOfBoxes: string;
  paymentMode: string;
  orderAmount: string;
  invoiceUrl: string;
  printInvoicePopUp: string = 'N';
  shippingList: any = [];
  tabClicked = "packing";
  stockShipLines: Array<StockShipmentLine>;
  allShipLines: Array<StockShipmentLine>;
  stockShipLine: StockShipmentLine = {};
  configLineIdSeq: number = 1;
  totalWeight: number;
  productConfig: string;
  orderStatusValue: string;
  singleBoxWeightTemp: number;
  packagesList = [];
  shippingCost: any = [];
  numberOfBoxesM: string;
  reviewOrder: any = {};
  boxesCount: number = 0;
  order: OrderHeader = {};

  costEstimateList: any = {};
  errorMessage1: string;
  shippingOptionError: string;
  quantityError: string;
    selectReasonError: string;
    reasonsList: any = [];
    returnOrderlines: any = [];
    orderLine: any = {};
    searchError: string = "";
    shipmentCarrierData: any;
    returnPickupCarrierlist : any = [];
    costEstimation : any[];
    costEstimate : any;

    length: string;
    lengthError: string;
    width: string;
    widthError: string;
    height: string;
    heightError: string;
    weight: string;
    weightError: string;
    quantity : any;
    orderError = {};
    meta : any;
      orderLines: OrderLine[] = [];



  constructor(private alertService: AlertService, public st: OrderHeader, public user: User, private http: HttpClient, private g: Globals, private route: ActivatedRoute,
    private router: Router, private api: ApiIntegration) {
    this.g.loaderDisplay = "display";
    this.api.getReturnOrder(this.route.snapshot.params['id']).subscribe((data: OrderHeader) => {
      this.g.loaderDisplay = "";
      this.reviewOrder = data;
      this.orderLines = this.reviewOrder.lines;
    }, err => {
        this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
    this.packageApi();
  }

  ngOnInit() {}

  packageApi(){
    this.api.getPackingTypesList("1").subscribe((data: any) => {
       this.package = data.getPackingTypesResponses;
       this.package.push({ packingType: 'Custom', height: '', width: '', lenght: '', weight: '' });
     }, err => {
       this.alertService.error('Error', err);
     });
  }

 changeBox() {
    if (this.numberOfBoxes != '') {
      this.reviewOrder.lines.forEach((ol) => {
        ol.shipLines = [];
        for (let i = 1; i <= Number(this.numberOfBoxesM); i++) {
          ol.shipLines.push({
            numberOfBoxes: Number(this.numberOfBoxesM),
            quantityPerBox: 0,
            productId: ol.productId,
            orderLineId: ol.orderLineId,
            configLineId: this.configLineIdSeq,
            boxNumber: i,
            boxHeight: null,
            boxWidth: null,
            boxLength: null,
            boxWeight: null,
            totalQuantity: null
          });
        }
      });
    } else {
    }
  }

  showAddShipRow(row) {
    let show = false;
    let totalQuantity = 0;
    row.shipLines.forEach((r) => {
      totalQuantity = totalQuantity + ((r.quantityPerBox || 0) * (r.numberOfBoxes || 0));
    });
    if (row.quantity == totalQuantity) {
      show = true;
    } else {
      this.statusText8 = 'Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing';
    }
    return show;
  }

  populateDimensions(row) {
    if (row.packageType) {
      let index = this.package.findIndex((d) => d.packingType === row.packageType);
      if (index > -1) {
        row.boxHeight = this.package[index].height;
        row.boxWidth = this.package[index].width;
        row.boxLength = this.package[index].length;
        row.boxWeight = this.package[index].weight;
      }
    }
  }

  totalWeightCal() {
    this.totalWeight = 0;
    let calQuantityWeight = '';
    if (this.productConfig == 'SKU') {
      for (let o of this.reviewOrder.lines) {
        o.totalWeight = (Number(o.quantityWeight) || 0) * (Number(o.numOfBoxesTmp) || 0);
        this.totalWeight = this.totalWeight + o.totalWeight;
      }
    } else {
      for (let o of this.reviewOrder.lines[0].shipLines) {
        this.singleBoxWeightTemp = (Number(o.singleBoxWeight) || 0);
        this.totalWeight = Number(this.totalWeight) + (Number(this.singleBoxWeightTemp));
      }
    }
  }

  openPackage() {
    this.packagesList = this.package;
  }

 showAddShipmentBtn(row) {
   this.statusText9 = "";
   let show = true;
   let totalQuantity = 0;
   row.shipLines.forEach((r) => {
     totalQuantity = totalQuantity + ((r.quantityPerBox || 0) * (r.numberOfBoxes || 0));
   });
   if (row.quantity == totalQuantity) {
     show = false;
   }
   totalQuantity = totalQuantity + ((row.numOfBoxesTmp || 0) * (row.qtyPerBoxTmp || 0));
   if (row.quantity < totalQuantity) {
     this.statusText9 = 'Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing';
     show = false;
   }
   return show;
 }

 removeShipmentLine(r, s) {
   let index = r.shipLines.indexOf(s);
   r.shipLines.splice(index, 1);
   let boxWg = 0;
   r.shipLines.forEach((ele) => {
     if (ele.quantityPerBox != null && ele.numberOfBoxes != null)
       boxWg = boxWg + (ele.quantityPerBox * ele.numberOfBoxes);
   });
   r.totalQuantity = boxWg;
 }

  selectPackType() {
    this.reviewOrder.lines.forEach((ol) => {
      for (let i = 0; i < ol.shipLines.length; i++) {
        ol.shipLines[i].packageType = this.reviewOrder.lines[0].shipLines[i].packageType;
      }
    });
    console.log(this.reviewOrder.lines);
  }

  showShipIcon(row) {
    this.statusText7 = "";
    let show = false;
    let totalQuantity = 0;
    totalQuantity = totalQuantity + ((row.numOfBoxesTmp || 0) * (row.qtyPerBoxTmp || 0));
    row.shipLines.forEach((r) => {
      totalQuantity = totalQuantity + ((r.quantityPerBox || 0) * (r.numberOfBoxes || 0));
    });
    if (row.quantity == totalQuantity) {
      show = true;
    }
    if (row.quantity != totalQuantity) {
      this.statusText7 = 'Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing';
      show = false;
    }
    return show;
  }

  addShipmentLine(o) {
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    if (!Number(o.qtyPerBoxTmp) || o.qtyPerBoxTmp === null || o.qtyPerBoxTmp === undefined) {
      this.statusText2 = 'Please enter quantity';
    }
    if (!Number(o.numOfBoxesTmp) || o.numOfBoxesTmp === null || o.numOfBoxesTmp === undefined) {
      this.statusText3 = 'Please enter no.of boxes';
    }
    if (o.packageType === null || o.packageType === undefined) {
      this.statusText4 = 'Please select package type';
    }
    if (o.boxHeight === null || o.boxHeight === undefined || o.boxLength === null || o.boxLength === undefined || o.boxWidth === null || o.boxWidth === undefined) {
      this.statusText5 = 'Please enter l*w*h';
    }
    if (o.quantityWeight === null || o.quantityWeight === undefined) {
      this.statusText6 = 'Please enter weight';
    }
    if (this.statusText2 != "" || this.statusText3 != "" || this.statusText4 != "" || this.statusText5 != "" || this.statusText6 != "") {
      return false;
    }
    if (o != null) {
      this.stockShipLines = (_.cloneDeep(o.shipLines));
      if (this.stockShipLines == null) {
        this.stockShipLines = [];
      }
      this.stockShipLine.numberOfBoxes = o.numOfBoxesTmp;
      this.stockShipLine.quantityPerBox = o.qtyPerBoxTmp;
      this.stockShipLine.productId = o.productId;
      this.stockShipLine.packageType = o.packageType;
      this.stockShipLine.orderLineId = o.orderLineId;
      this.stockShipLine.configLineId = this.configLineIdSeq;
      this.stockShipLine.boxHeight = o.boxHeight;
      this.stockShipLine.boxWidth = o.boxWidth;
      this.stockShipLine.boxLength = o.boxLength;
      this.stockShipLine.boxWeight = o.boxWeight;
      this.stockShipLine.quantityWeight = o.quantityWeight;
      this.stockShipLine.totalWeight = o.totalWeight || this.totalWeight;
      this.stockShipLine.productWeight = o.productWeight;
      this.stockShipLine.totalQuantity = (o.numOfBoxesTmp * o.qtyPerBoxTmp);
      this.stockShipLines.push(_.cloneDeep(this.stockShipLine));
      o.shipLines = _.cloneDeep(this.stockShipLines);
      let boxWg = 0;
      o.shipLines.forEach((ele) => {
        if (ele.quantityPerBox != null && ele.numberOfBoxes != null)
          boxWg = boxWg + (ele.quantityPerBox * ele.numberOfBoxes);
      });
      o.totalQuantity = boxWg;
      o.numOfBoxesTmp = null;
      o.qtyPerBoxTmp = null;
      o.boxHeight = null;
      o.packageType = undefined;
      o.boxWidth = null;
      o.boxLength = null;
      o.boxWeight = null;
      o.productWeight = o.productWeight;
      ;
      this.stockShipLine = {};
      this.configLineIdSeq = this.configLineIdSeq + 1;
    }
  }

  tabChange(tab) {
    this.tabClicked = tab
  }

  change() {
    this.numberOfBoxesM = "1";
    for (let sl of this.reviewOrder.lines) {
      sl.numOfBoxesTmp = null;
      sl.qtyPerBoxTmp = null;
      sl.boxHeight = null;
      sl.boxWidth = null;
      sl.boxLength = null;
      sl.boxWeight = null;
      sl.totalQuantity = null;
      sl.quantityWeight = null;
      sl.totalWeight = null;
      sl.packageType = undefined;
      sl.shipLines = [{
        numberOfBoxes: null,
        quantityPerBox: null,
        productId: sl.productId,
        configLineId: this.configLineIdSeq,
        boxHeight: null,
        boxWidth: null,
        boxLength: null,
        boxWeight: null,
        totalQuantity: null
      }];
    }
  }

  reviewAndConfirm() {
    this.step = 2;
  }


  fieldsEntered(row) {
    let show = true;
    let textEntered = false;
    row.shipLines.forEach((r) => {
      if (r.quantityPerBox !== '' && r.quantityPerBox !== undefined && r.quantityPerBox) {
        textEntered = true;
      }
    });
    if (!textEntered) {
      show = false;
    }
    return show;
  }

  clearFields() {
      this.productConfig = '';
      this.statusText2 = "";
      for (let o of this.reviewOrder.lines) {
        o.qtyPerBoxTmp = null;
        o.numOfBoxesTmp = null;
        o.boxHeight = null;
        o.boxLength = null;
        o.boxWidth = null;
        o.boxWeight = null;
        o.packageType = undefined,
          o.shipLines = [{
            numberOfBoxes: null,
            quantityPerBox: null,
            productId: o.productId,
            orderLineId: o.orderLineId,
            packageType: undefined,
            boxHeight: null,
            boxWidth: null,
            boxLength: null,
            boxWeight: null,
            totalQuantity: null
          }];
      }
      this.statusText2 = "";
      this.statusText3 = "";
      this.statusText4 = "";
      this.statusText5 = "";
      this.statusText6 = "";
      this.statusText7 = "";
      this.statusText8 = "";
      this.statusText9 = "";
      this.statusText10 = "";
      this.statusText11 = "";
      this.statusText12 = "";
  }

  /* costEstimatee() {
    this.reviewOrder.lines.forEach((ol) => {
      ol.shipLines.forEach((sl) => {
        this.boxHeights = (this.boxHeights > sl.boxHeight ? this.boxHeights : sl.boxHeight);
        this.boxWidths = (this.boxWidths > sl.boxWidth ? this.boxWidths : sl.boxWidth);
        this.boxLengths = (this.boxLengths > sl.boxLength ? this.boxLengths : sl.boxLength);
      });
    });
    var header1 = new HttpHeaders();
    this.g.loaderDisplay = "display";
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + this.local.get('jwt'));
    this.http.post(environment.apiUrl + 'api/costEstimationForShiftAggregator', {
      "accountOwnerId": this.user.accountOwnerId,
      "destPincode": this.reviewOrder.deliveryAreaPinCode,
      "orderType": "PICK",
      "length": this.boxLengths,
      "breadth": this.boxWidths,
      "height": this.boxHeights,
      "paymentMethod": this.reviewOrder.paymentMethod,
      "orderValue": this.reviewOrder.totalValue,
      "organizationId": this.user.organizationId,
      "originPincode": this.reviewOrder.pickupAreaPinCode,
      "weight": this.totalWeight
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.costEstimateList = data;
          this.costEstimation = this.costEstimateList.costEstimateList;
          this.alertService.success('Cost Estimation', 'Submitted successfully');
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
 */
  showIcon(row) {
    let show = true;
    let totalQuantity = 0;
    row.shipLines.forEach((r) => {
      totalQuantity = Number(totalQuantity) + ((Number(r.quantityPerBox) || 0));
    });
    console.log(totalQuantity);
    console.log(row.quantity);
    if (Number(row.quantity) != totalQuantity) {
      show = false;
    }
    return show;
  }

   /* proceedShipRockForSE() {
        this.statusText10 = '';
       this.statusText11 = '';
       this.statusText12 = '';
     if (this.productConfig === 'SKU') {
       this.statusText8 = null;
       for (let sl of this.reviewOrder.lines) {
         if (sl.shipLines === null || sl.shipLines === undefined) {
           this.statusText8 = 'Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing';
           return false;
         }
         let totalQuantity = 0;
         sl.shipLines.forEach((r) => {
           totalQuantity = totalQuantity + ((r.quantityPerBox || 0) * (r.numberOfBoxes || 0));
         });
         if (sl.quantity != totalQuantity) {
           this.statusText9 = 'Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing';
           return false;
         }
       }
       this.allShipLines = [];
       for (let ol of this.reviewOrder.lines) {
         for (let i = 0; i < ol.shipLines.length; i++) {
           if (!ol.shipLines[i].quantityPerBox || !ol.shipLines[i].numberOfBoxes) {
             // ol.shipLines.splice(i,1);
           } else {
             this.allShipLines.push(ol.shipLines[i]);
           }
         }
       }
     } else {
       this.reviewOrder.lines[0].shipLines.forEach((r) => {
         if (!r.packageType) {
           this.statusText10 = 'Please select package type';
           return false;
         } else if (r.packageType === 'Custom') {
           if (!r.boxHeight || !r.boxWidth || !r.boxLength) {
             this.statusText11 = 'Please enter length, width and height dimentions';
             return false;
           }
         }
       });
       this.reviewOrder.lines.forEach((s) => {
         if (!this.showIcon(s)) {
           this.statusText12 = 'Shipment quantity is not matched';
           return false;
         }
       });
       if (this.statusText10 !== "" || this.statusText11 !== "" || this.statusText12 !== "") {
         return false;
       }
       this.allShipLines = [];
       for (let ol = 0; ol < this.reviewOrder.lines.length; ol++) {
         for (let i = 0; i < this.reviewOrder.lines[ol].shipLines.length; i++) {
           if (!this.reviewOrder.lines[ol].shipLines[i].quantityPerBox) {
             this.reviewOrder.lines[ol].shipLines[i].quantityPerBox = 0;
           }
           if (ol > 0) {
             this.reviewOrder.lines[ol].shipLines[i].boxHeight = this.reviewOrder.lines[0].shipLines[i].boxHeight;
             this.reviewOrder.lines[ol].shipLines[i].boxWidth = this.reviewOrder.lines[0].shipLines[i].boxWidth;
             this.reviewOrder.lines[ol].shipLines[i].boxLength = this.reviewOrder.lines[0].shipLines[i].boxLength;
             this.reviewOrder.lines[ol].shipLines[i].boxWeight = this.reviewOrder.lines[0].shipLines[i].boxWeight;
             this.reviewOrder.lines[ol].shipLines[i].quantityWeight = this.reviewOrder.lines[0].shipLines[i].quantityWeight;
             this.reviewOrder.lines[ol].shipLines[i].totalWeight = this.reviewOrder.lines[0].shipLines[i].totalWeight;
             this.reviewOrder.lines[ol].shipLines[i].boxNumber = this.reviewOrder.lines[0].shipLines[i].boxNumber;
             this.reviewOrder.lines[ol].shipLines[i].qtyPerBox = this.reviewOrder.lines[0].shipLines[i].quantityPerBox;
             this.reviewOrder.lines[ol].shipLines[i].totalQuantity = Number(this.reviewOrder.lines[0].shipLines[i].quantityPerBox) * Number(this.reviewOrder.lines[0].shipLines[i].boxNumber);
           }
         }
         this.allShipLines = [...this.allShipLines, ...this.reviewOrder.lines[ol].shipLines];
       }
     }
     if (this.productConfig == 'SKU') {
       this.allShipLines.forEach((t) => {
         this.totalBoxes = Number(this.totalBoxes) + Number(t.numberOfBoxes || 0);
       });
     } else {
       this.totalBoxes = Number(this.numberOfBoxesM);
     }
     this.allShipLines.forEach((l) => {
       l.qtyPerBox = l.quantityPerBox || 0;
     });
         this.tabClicked = 'carrier';
         this.costEstimate();
    }
 */
 submitOrderForShipment() {
   if(this.shippingCost.deliveryMode == undefined){
     this.shipType = this.shippingCost.serviceType;
   } else if( this.shippingCost.serviceType == undefined){
     this.shipType = this.shippingCost.deliveryMode;
   }

   var header1 = new HttpHeaders();
   this.g.loaderDisplay = "display";
   header1 = header1.append('Content-Type', 'application/json');
   header1 = header1.append('Accept', 'application/json');
   header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
   this.http.post(environment.apiUrl + 'api/updatePackingConfigurationForReturnOrders',{
     "accountOwnerId": this.user.accountOwnerId,
     "orderHeaderId": this.reviewOrder.orderHeaderId,
     "orderStatus": "SUBMITTED",
     "organizationId": 1,
     "productConfig": this.productConfig,
     "shipLines": this.allShipLines,
     "shipmentPrice": this.shippingCost.totalAmount,
     "shippingMethod": "PARCEL",
     "shippingOption": this.shippingCost.carrierCode,
     "shippingType": this.shipType,
     "totalBoxes": this.totalBoxes || 0
    },
     { headers: header1 }).subscribe(data => {
       this.g.loaderDisplay = "";
       if (data['code'] == 200) {
         this.alertService.success('OrderProcessing', 'Submitted successfully');
         this.router.navigate(['/admin/orders']);
       } else {
         this.alertService.error('Error', data['message']);
       }

     },

       (err: HttpErrorResponse) => {
         this.g.loaderDisplay = "";

       });
 }



 carrier(){
   this.costEstimation?.forEach((shipMent : any) => {
     shipMent?.costEstimates?.forEach((cost : any) => {

        this.returnPickupCarrierlist.push(cost);

       return this.returnPickupCarrierlist;
     })
     console.log(this.returnPickupCarrierlist);
   })
 }

 selectCost(o){
 this.shippingCost = o;
 }

 typeLength(){
     this.lengthError = "";
     if (!this.length) {
         this.lengthError = 'Please enter length';
     }
   }

   typeWidth(){
   this.widthError = "";
    if (!this.width) {
        this.widthError = 'Please enter width';
    }
   }

   typeHeight(){
   this.heightError = "";
     if (!this.height) {
         this.heightError = 'Please enter height';
     }
   }

   typeWeight(){
     if (!this.weight) {
         this.weightError = 'Please enter weight';
     }
   }



   submitCostEstimation(){
        if(this.costEstimation && this.costEstimation.length > 0){
                     return;
          }
        this.lengthError = "";
        this.widthError = "";
        this.heightError = "";
        this.weightError = "";
             if (!this.length) {
                 this.lengthError = 'Please enter length';
             }
             if (!this.width) {
                 this.widthError = 'Please enter width';
             }
             if (!this.height) {
                 this.heightError = 'Please enter height';
             }
             if (!this.weight) {
                 this.weightError = 'Please enter weight';
             }
           if ( this.lengthError != '' || this.widthError != '' || this.heightError != '' || this.weightError != '') {
                   return false;
           }
         this.g.loaderDisplay = "display";
         var header1 = new HttpHeaders();
         this.g.loaderDisplay = "display";
         header1 = header1.append('Content-Type', 'application/json');
         header1 = header1.append('Accept', 'application/json');
         header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
         this.http.post(environment.apiUrl + 'api/costEstimationForShiftAggregator', {
           "breadth": this.width,
           "destPincode": this.reviewOrder.pickupAreaPinCode,
           "originPincode": this.reviewOrder.deliveryAreaPinCode,
           "height": this.height,
           "length": this.length,
           "orderType": "PICK",
           "organizationId": this.user.organizationId,
           "paymentMethod":"Reverse",
           "weight": this.weight,
           },
           {headers: header1}).subscribe(data => {
             this.g.loaderDisplay = "";
             if (data['code'] == 200) {
               this.costEstimate = data;
               this.costEstimation = this.costEstimate.costEstimateList;
               this.carrier();
               this.alertService.success('Cost Estimation', 'Submitted successfully');
             }
           },
           (err) => {
             this.g.loaderDisplay = "";
             this.alertService.error('Error', err);
           });
     }


      Submit() {
       let dimensions : any ={
                           breadth: this.width,
                           height: this.height,
                           length: this.length,
                           weight: this.weight,
                           };
                           for(let ol of this.orderLines){
                             this.orderLine.orderLineId= ol.orderLineId;
                             this.orderLine.returnOrderLineId= ol["returnOrderLineId"];
                             this.orderLine.returnQuantity = ol.quantity;
                             this.orderLine.productId = ol.productId;
                             this.returnOrderlines.push(_.cloneDeep(this.orderLine));
                           }
         let details : any = {
                   shipMethod: "PARCEL",
                   shippingOption: this.shippingCost.carrierCode,
                   shippingType:this.shippingCost.serviceType || this.shippingCost.deliveryMode,
                   shipmentPrice: this.shippingCost.totalAmount,
                   destination: this.reviewOrder.pickupAreaPinCode,
                   origin: this.reviewOrder.deliveryAreaPinCode,
                   totalBoxes: 1
         }

         this.g.loaderDisplay = "display";
         var header1 = new HttpHeaders();
         header1 = header1.append("Content-Type", "application/json");
         header1 = header1.append("Accept", "application/json");
         header1 = header1.append(
           "Authorization",
           "Bearer " + localStorage.getItem("jwt")
         );
         this.http
           .post(
             environment.apiUrl + "api/orders/"+this.reviewOrder.orderNumber +"/return-orders",
             {
     /*        accountOwnerContactId: this.order.accountOwnerCustomerId,
               additionalInfo: this.order.additionalInfo,
               lines: this.orderLines,
               awbNumber: this.order.awbNumber,
               connectionName: this.order.connectionName,
               deliveryInstructions: this.order.deliveryInstructions,
               externalOrderId: this.order.sourceOrderId || "",
               externalShipmentId: "string",
               //"inProcessDate": "2020-10-01T02:22:36.391Z",
               originalOrderDate: this.order.createdDate,
               originalOrderHeaderId: this.order.orderHeaderId,
               pickupAddressId: 0,
               productConfig: this.order.productConfig,
               providerStatus: this.order.providerStatus,
               receivedDate: "2020-10-01T02:22:36.392Z",
               referenceOrderId: "string",
               returnOrderDate: "string",
               returnOrderHeaderId: 0,
               shipmentPrice: 0,
               shippingMethod: this.order.shippingMethod,
               shippingOption: this.order.shippingOption,
               sourceOrderDate: this.order.sourceOrderDate,
               sourceType: "string",
               trackingNumber: this.order.trackingNumber,
               warehouseId: this.order.warehouseId,
               "orderNumber": this.order.orderNumber,
               "accountOwnerId": this.order.accountOwnerId,
               "destPincode": this.order.pickupAreaPinCode,
               "originPincode": this.order.deliveryAreaPinCode,
               "orderStatus": "SUBMITTED",
               "orderType": this.order.orderType,
               "returnReason": this.order.returnReason,*/
               "organizationId": 1,
               "accountOwnerId": this.reviewOrder.accountOwnerId,
               "returnReason" : this.reviewOrder.returnReason,
               "orderLines": this.returnOrderlines,
               "shippingDetails": details,
               "dimensions":dimensions,

             },
             { headers: header1 }
           )
           .subscribe(
             (data : any) => {
               this.g.loaderDisplay = "";
               if (data["code"] == 200) {
               this.returnOrderlines=[];
                 this.alertService.success("Order", "Return Successfully");
                 if (this.user.role == "ACCOUNT_OWNER" || this.user.role ==  'AO_SELLER') {
                   this.router.navigate(["/admin/returns"]);
                 } else {
                   this.router.navigate(["/admin/adminReturns"]);
                 }
               } else {
               this.g.loaderDisplay = "";
               this.alertService.error("Error", data["message"]);
               }
             },
             (err) => {
             this.returnOrderlines=[];
               this.g.loaderDisplay = "";
               this.alertService.error("Error", err);
             }
           );
       }

       moveToShipping() {
          this.tabClicked = "carrier";
        }




}
